import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { Props } from '../../../SectionViewSwitch';
import { AppState } from '../../../../../types/store';
import { getViewType } from '../../../../selectors/gallectionSection';
import { setViewType } from '../../../../actions/gallectionSection';

export type StateProps = Pick<Props, 'value'>;
export type DispatchProps = Pick<Props, 'onChange'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  value: getViewType(state),
});
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  onChange: setViewType,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
);
